import axios from "axios";

import {ORDERS_URL} from './api/apiUrls'

export const ordersApi = axios.create({
    baseURL: ORDERS_URL,
    timeout: 120000,
    transformRequest: [function (data, headers) {
        headers['Authorization'] = headers['Authorization'] || window.localStorage.getItem('$LoopBack$accessTokenId')
        headers['ownerId'] = window.localStorage.getItem('Idha.ownerId').replace(/\"/g,"")
        return JSON.stringify(data)
      }],
    headers: {
        'Content-Type': 'application/json'
    }
})
